<template>
  <div id="wrap" :class="bgClass">
    <img class="logo" @click="goHome" :src="img" alt="">
    <div class="title">{{tit}}</div>
    <div class="content">
      <div class="content_left">
        <img :src="lefImg" alt="">
      </div>
      <div class="content_right">
        <regisrerM v-if="current ==0" @func="getMsgSon_f"></regisrerM>
        <regisrerE v-if="current ==1" @func="getMsgSon_f"></regisrerE>
        <regisrerP v-if="current ==2" @func="getMsgSon_f"></regisrerP>
        <regisrerW v-if="current ==3" :params="params" @func="getMsgSon_f"></regisrerW>
        <regisrerR v-if="current ==4" @func="getMsgSon_f"></regisrerR>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" top="30vh" center>
      <div class="line"></div>
      <i></i>
      <div>申请提交成功，我们将在2个工作日内 <br>与您联系，谢谢！</div>

    </el-dialog>
  </div>
</template>

<script>
import regisrerM from "../../views/login/login_in"
import regisrerE from "../../views/login/login_register"
import regisrerP from "../../views/login/login_up"
import regisrerW from "../../views/login/wxAddress"
import regisrerR from "../../views/login/relation"
export default {
  props: {

  },
  components: {
    regisrerM,
    regisrerE,
    regisrerP,
    regisrerW,
    regisrerR
  },
  data () {
    return {
      current: 0,//0代表扫码账号注册 1代表注册 2代表忘记密码
      screenWidth: document.documentElement.clientWidth,//屏幕宽度
      tit: "飞译CAT-民族语",
      img: require("../../assets/imgs/login/logo_fy.png"),
      bgClass: "",
      lefImg: require("../../assets/imgs/login/nation.png"),
      centerDialogVisible: false,
      params: {},
    };
  },
  created () {

    if (window.innerWidth > 992 && window.innerWidth < 1366) {
      document.body.style.zoom = 0.8;
    } else if (window.innerWidth < 992) {
      document.body.style.zoom = 0.7;
    }
    if (window.innerHeight < 640) {
      document.body.style.zoom = 0.6;
    }

  },
  mounted () {
    let _this = this;
    window.onresize = function () { // 定义窗口大小变更通知事件
      _this.screenWidth = document.documentElement.clientWidth; //窗口宽度
      if (_this.screenWidth > 992 && _this.screenWidth < 1366) {
        document.body.style.zoom = 0.8;
      } else if (_this.screenWidth < 992) {
        document.body.style.zoom = 0.7;
      } else {
        document.body.style.zoom = 1;
      }
    };
  },

  methods: {
    goHome () {
      this.$router.push({
        name:"homepage"
      })
    },
    getMsgSon_f (data, params) {
      this.current = data
      this.params = params
    },


  }
};
</script>

<style lang="less" scoped>
#wrap {
  position: relative;

  width: 100%;
  height: 100%;
  background: url(../../assets/imgs/login/nation_bg.png);
  background-size: cover;

  .logo {
    position: relative;
    left: 40px;
    top: 23px;
    cursor: pointer;
  }
  .title {
    position: absolute;
    left: 50%;
    top: 108px;
    transform: translateX(-50%);
    font-size: 38px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
  }
  .content {
    position: absolute;
    left: 50%;
    top: 219px;
    transform: translateX(-50%);
    width: 913px;
    height: 566px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 15px 0px rgba(26, 157, 181, 0.3);
    border-radius: 10px;
    .content_left {
      position: relative;
      left: -1px;
      width: 456px;
      height: 566px;
      // background: rgba(229, 241, 255, 1);
      background: linear-gradient(
        -55deg,
        rgba(20, 91, 196, 1),
        rgba(60, 141, 240, 1)
      );
      border-radius: 10px 0px 0px 10px;
      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .content_right {
      position: absolute;
      right: 0;
      top: 0;
      width: 456px;
      height: 566px;
    }
  }
  /deep/.el-dialog {
    width: 380px !important;
    height: 230px !important;
    border-radius: 6px;
    .line {
      width: 100%;
      height: 1px;
      background: #ece6e6;
    }
    .el-dialog__header {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(69, 69, 69, 1);
    }
    .el-dialog__body {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 5px;
      div {
        text-align: center;
        font-size: 15px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(69, 69, 69, 1);
        line-height: 20px;
      }
      i {
        width: 39px;
        height: 39px;
        margin-top: 32px;
        margin-bottom: 5px;
        display: inline-block;
        background: url("../../assets/imgs/login/tc_tjcg.png") no-repeat;
        background-size: cover;
      }
    }
  }
}
</style>
